"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PermissionsProvider = exports.AssetPermissions = exports.ContentPermissions = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _sdk = require("@civicplus/hcms-api-sdk/dist/sdk");

var _Resource = require("../Utility/Resource");

var _TypeGuards = require("../Utility/TypeGuards");

var _Cache = require("../Utility/Cache");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Permissions = function Permissions(links) {
  (0, _classCallCheck2["default"])(this, Permissions);
  (0, _defineProperty2["default"])(this, "canCreateAndPublish", void 0);
  (0, _defineProperty2["default"])(this, "canDelete", void 0);
  (0, _defineProperty2["default"])(this, "canDraftCreate", void 0);
  (0, _defineProperty2["default"])(this, "canUpdate", void 0);
  (0, _defineProperty2["default"])(this, "canCreate", void 0);
  (0, _defineProperty2["default"])(this, "statusUpdates", []);
  this.statusUpdates = Object.keys(links).filter(function (x) {
    return x.startsWith("status/");
  }).map(function (x) {
    return {
      status: x.substr(7),
      color: links[x].metadata
    };
  });
  this.canDelete = (0, _Resource.hasAnyLink)(links, "delete");
  this.canDraftCreate = (0, _Resource.hasAnyLink)(links, "draft/create");
  this.canUpdate = (0, _Resource.hasAnyLink)(links, "update");
  this.canCreateAndPublish = (0, _Resource.hasAnyLink)(links, "create/publish");
  this.canCreate = (0, _Resource.hasAnyLink)(links, "create");
};

var ContentPermissions = /*#__PURE__*/function (_Permissions) {
  (0, _inherits2["default"])(ContentPermissions, _Permissions);

  var _super = _createSuper(ContentPermissions);

  function ContentPermissions(item) {
    var _item$_links;

    (0, _classCallCheck2["default"])(this, ContentPermissions);
    return _super.call(this, (_item$_links = item._links) !== null && _item$_links !== void 0 ? _item$_links : item);
  }

  return ContentPermissions;
}(Permissions);

exports.ContentPermissions = ContentPermissions;

var AssetPermissions = /*#__PURE__*/function (_Permissions2) {
  (0, _inherits2["default"])(AssetPermissions, _Permissions2);

  var _super2 = _createSuper(AssetPermissions);

  function AssetPermissions(item) {
    var _item$_links2;

    (0, _classCallCheck2["default"])(this, AssetPermissions);
    return _super2.call(this, (_item$_links2 = item._links) !== null && _item$_links2 !== void 0 ? _item$_links2 : item);
  }

  return AssetPermissions;
}(Permissions);

exports.AssetPermissions = AssetPermissions;

var PermissionsProvider = /*#__PURE__*/function () {
  function PermissionsProvider() {
    (0, _classCallCheck2["default"])(this, PermissionsProvider);
  }

  (0, _createClass2["default"])(PermissionsProvider, [{
    key: "load",
    value: function () {
      var _load = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(config, item, schema) {
        var _item$permissionSet, _schema$name;

        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _Cache.cacheGet)("permissions_".concat(item.version, "_").concat((_item$permissionSet = item.permissionSet) === null || _item$permissionSet === void 0 ? void 0 : _item$permissionSet.id, "_").concat((_schema$name = schema === null || schema === void 0 ? void 0 : schema.name) !== null && _schema$name !== void 0 ? _schema$name : ""), /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
                  var _schema$name2, _content$permissionSe;

                  var _item$permissionSet2, _links, content, links;

                  return _regenerator["default"].wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!(0, _TypeGuards.isAsset)(item)) {
                            _context.next = 10;
                            break;
                          }

                          if (!item.id) {
                            _context.next = 5;
                            break;
                          }

                          _context.t0 = item._links;
                          _context.next = 8;
                          break;

                        case 5:
                          _context.next = 7;
                          return new _sdk.AssetsApi(config).getPermissions(config.appName, (_item$permissionSet2 = item.permissionSet) === null || _item$permissionSet2 === void 0 ? void 0 : _item$permissionSet2.id);

                        case 7:
                          _context.t0 = _context.sent;

                        case 8:
                          _links = _context.t0;
                          return _context.abrupt("return", new AssetPermissions(_links));

                        case 10:
                          content = item;

                          if (!content.id) {
                            _context.next = 15;
                            break;
                          }

                          _context.t1 = content._links;
                          _context.next = 18;
                          break;

                        case 15:
                          _context.next = 17;
                          return new _sdk.ContentsApi(config).getPermissions(config.appName, (_schema$name2 = schema === null || schema === void 0 ? void 0 : schema.name) !== null && _schema$name2 !== void 0 ? _schema$name2 : "", (_content$permissionSe = content.permissionSet) === null || _content$permissionSe === void 0 ? void 0 : _content$permissionSe.id);

                        case 17:
                          _context.t1 = _context.sent;

                        case 18:
                          links = _context.t1;
                          return _context.abrupt("return", new ContentPermissions(links));

                        case 20:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })));

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function load(_x, _x2, _x3) {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }]);
  return PermissionsProvider;
}();

exports.PermissionsProvider = PermissionsProvider;